module.exports = __webpack_public_path__ + "img/receta.69e0e21c.svg";